import { defineStore } from 'pinia';
export const useStore = defineStore('app', {
  state: () => ({
    //搜索页 过滤参数
    searchParams: {
      q: '',//搜索关键字
      page: 1,
      limit: 10,
      database_name: '',
    }
  }),
  actions: {
    setSearchParams(params) {
      this.searchParams = {
        ...this.searchParams,
        ...params
      };
    }
  },
});